<template>
  <WidgetCadre
    titre="Alertes de stock"
    v-bind="apparence"
    :lien="donnees?.lien || '/stock/dashboard'"
    :chargement="chargement"
    :panne="panne"
    :reglable="reglable"
    :etat="etat"
    @retirer="$emit('retirer')"
    @recharger="$emit('recharger')"
  >
    <!-- Un compteur nul n'est pas un zéro : le serveur renvoie `null` quand le
         droit fin manque. Afficher « 0 en rupture » à qui n'a pas le droit de
         le savoir serait une affirmation, et elle serait fausse. -->
    <dl class="stock">
      <div
        v-for="compteur in compteurs"
        :key="compteur.libelle"
        class="stock__ligne"
      >
        <dd
          class="chiffre chiffre--moyen"
          :class="{ 'stock--alerte': compteur.valeur > 0 }"
        >
          {{ compteur.valeur }}
        </dd>
        <dt class="etiquette">
          {{ compteur.libelle }}
        </dt>
      </div>
    </dl>

    <p
      v-if="toutMasque"
      class="etiquette"
    >
      Aucun de ces compteurs ne vous est ouvert.
    </p>

    <p
      v-else-if="toutCalme"
      class="etiquette stock__calme"
    >
      Rien à signaler.
    </p>
  </WidgetCadre>
</template>

<script setup>
import { computed } from 'vue'
import WidgetCadre from './WidgetCadre.vue'
import { apparenceDe } from './apparence'

const props = defineProps({
    donnees: { type: Object, default: null },
    chargement: { type: Boolean, default: false },
    panne: { type: Boolean, default: false },
    reglable: { type: Boolean, default: false },
})

defineEmits(['retirer', 'recharger'])

const apparence = apparenceDe('stock-alertes')

const compteurs = computed(() =>
    [
        { libelle: 'sous le seuil', valeur: props.donnees?.sous_seuil },
        { libelle: 'en rupture', valeur: props.donnees?.en_rupture },
        { libelle: 'commandes en retard', valeur: props.donnees?.commandes_retard },
    ].filter(compteur => compteur.valeur !== null && compteur.valeur !== undefined),
)

const toutMasque = computed(() => props.donnees !== null && compteurs.value.length === 0)
const toutCalme = computed(() => compteurs.value.length > 0 && compteurs.value.every(c => c.valeur === 0))

const etat = computed(() => {
    if (!props.donnees || compteurs.value.length === 0) return 'repos'

    return compteurs.value.some(c => c.valeur > 0) ? 'attention' : 'sain'
})
</script>

<style lang="scss" scoped>
.stock {
  display: flex;
  flex-direction: column;
  gap: 7px;
  margin: 0;

  &__ligne {
    display: flex;
    align-items: baseline;
    gap: 10px;

    dd { margin: 0; min-width: 28px; }
    dt { margin: 0; }
  }

  &--alerte { color: var(--accueil-attention); }

  &__calme {
    margin: 9px 0 0;
    padding-top: 9px;
    border-top: 1px solid var(--el-border-color-lighter);
  }
}
</style>
